import { Box, Typography } from '@mui/material';
import React from 'react';

type InputCharCounterProps = {
  max: number;
  current: number;
};

export const InputCharCounter = ({ max, current }: InputCharCounterProps) => (
  <Box
    sx={{
      width: '100%',
    }}
  >
    <Typography sx={{ textAlign: "end", fontSize: 13 }}>{`${current}/${max}`}</Typography>
  </Box>
);
